import Button from 'shared/buttons';
import React from 'react';
import { useSelector } from 'react-redux';
import { MODES } from 'src/theme';

export const SelectAllButton = ({ id = 'select-all-button', allSelected, ...props }) => {
  const themeMode = useSelector(({ app }) => app?.themeMode);
  const isDarkMode = themeMode === MODES.DARK;

  return (
    <Button
      id={id}
      data-testid={id}
      title={allSelected ? 'Unselect All' : 'Select All'}
      icon={allSelected ? 'x' : 'check'}
      themeColor={isDarkMode ? 'primary' : 'tertiary'}
      fillMode={allSelected ? undefined : 'outline'}
      {...props}
    />
  );
};
